// // import { Box, Skeleton, Stack } from "@mui/material";
// // import { useEffect, useRef, useState } from "react";

// // export default function GoogleNews({ query }) {
// //   const [news, setNews] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const [error, setError] = useState(false);

// //   const hasFetched = useRef(false);

// //   useEffect(() => {
// //     const controller = new AbortController();

// //     fetchNews(query, controller.signal);

// //     return () => {
// //       controller.abort(); // ⬅️ cancels duplicate calls
// //     };
// //   }, [query]);

// //   // async function fetchNews(searchQuery) {
// //   //   try {
// //   //     setLoading(true);
// //   //     setError(false);

// //   //     const rssUrl = `https://news.google.com/rss/search?q=${encodeURIComponent(
// //   //       searchQuery
// //   //     )}&hl=en-US&gl=US&ceid=US:en`;

// //   //     const response = await fetch(
// //   //       `https://api.allorigins.win/get?url=${encodeURIComponent(rssUrl)}`
// //   //     );

// //   //     const data = await response.json();

// //   //     const parser = new DOMParser();
// //   //     const xml = parser.parseFromString(data.contents, "application/xml");

// //   //     const items = Array.from(xml.querySelectorAll("item"));

// //   //     const parsedNews = [];

// //   //     items.forEach((item) => {
// //   //       const title = item.querySelector("title")?.textContent || "";
// //   //       const description =
// //   //         item.querySelector("description")?.textContent || "";
// //   //       const link = item.querySelector("link")?.textContent || "";
// //   //       const pubDate = item.querySelector("pubDate")?.textContent || "";
// //   //       const source =
// //   //         item.querySelector("source")?.textContent || "Google News";

// //   //       if (
// //   //         !title.toLowerCase().includes("trump") &&
// //   //         !description.toLowerCase().includes("trump")
// //   //       )
// //   //         return;

// //   //       const formattedDate = new Date(pubDate).toLocaleDateString("en-GB", {
// //   //         day: "2-digit",
// //   //         month: "short",
// //   //         year: "numeric",
// //   //       });

// //   //       // let imageUrl = "";
// //   //       // const mediaContent = item.querySelector("media\\:content, enclosure");

// //   //       let imageUrl = "";
// //   //       const mediaContent = item.querySelector("media\\:content, enclosure");
// //   //       if (mediaContent && mediaContent.getAttribute("url")) {
// //   //         imageUrl = mediaContent.getAttribute("url").trim();
// //   //       } else {
// //   //         const imgMatch = description.match(/<img.*?src=["'](.*?)["']/);
// //   //         if (imgMatch && imgMatch[1]) {
// //   //           imageUrl = imgMatch[1].trim();
// //   //         }
// //   //       }

// //   //       if (mediaContent?.getAttribute("url")) {
// //   //         imageUrl = mediaContent.getAttribute("url");
// //   //       } else {
// //   //         const match = description.match(/<img.*?src=["'](.*?)["']/);
// //   //         if (match?.[1]) imageUrl = match[1];
// //   //       }

// //   //       parsedNews.push({
// //   //         title,
// //   //         link,
// //   //         imageUrl,
// //   //         date: formattedDate,
// //   //         source,
// //   //       });
// //   //     });

// //   //     setNews(parsedNews);
// //   //   } catch (err) {
// //   //     console.error(err);
// //   //     setError(true);
// //   //   } finally {
// //   //     setLoading(false);
// //   //   }
// //   // }

// //   const keywordGroups = [
// //   ["Trump", "Biden", "Election"],
// //   ["USA", "Economy", "Fed"],
// //   ["Ukraine", "NATO", "Russia"],
// // ];

// // // for (const group of keywordGroups) {
// // //   await fetchNews(group);
// // // }

// //   // async function fetchNews(keywords = []) {
// //   //   try {
// //   //     setLoading(true);
// //   //     setError(false);

// //   //     // 1️⃣ Limit keywords
// //   //     const safeKeywords = keywords.slice(0, 6);

// //   //     // 2️⃣ OR-based query
// //   //     const query = safeKeywords.join(" | ");

// //   //     const rssUrl = `https://news.google.com/rss/search?q=${encodeURIComponent(
// //   //       query,
// //   //     )}&hl=en-US&gl=US&ceid=US:en`;

// //   //     const response = await fetch(
// //   //       `https://api.allorigins.win/raw?url=${encodeURIComponent(rssUrl)}`,
// //   //     );

// //   //     if (!response.ok) throw new Error("Network response failed");

// //   //     const xmlText = await response.text();

// //   //     const parser = new DOMParser();
// //   //     const xml = parser.parseFromString(xmlText, "application/xml");

// //   //     const items = Array.from(xml.querySelectorAll("item"));
// //   //     const parsedNews = [];

// //   //     items.forEach((item) => {
// //   //       const title = item.querySelector("title")?.textContent || "";
// //   //       const description =
// //   //         item.querySelector("description")?.textContent || "";
// //   //       const link = item.querySelector("link")?.textContent || "";
// //   //       const pubDate = item.querySelector("pubDate")?.textContent || "";
// //   //       const source =
// //   //         item.querySelector("source")?.textContent || "Google News";

// //   //       const formattedDate = new Date(pubDate).toLocaleDateString("en-GB", {
// //   //         day: "2-digit",
// //   //         month: "short",
// //   //         year: "numeric",
// //   //       });

// //   //       let imageUrl = "";
// //   //       const mediaContent = item.querySelector("media\\:content, enclosure");

// //   //       if (mediaContent?.getAttribute("url")) {
// //   //         imageUrl = mediaContent.getAttribute("url").trim();
// //   //       } else {
// //   //         const match = description.match(/<img.*?src=["'](.*?)["']/);
// //   //         if (match?.[1]) imageUrl = match[1].trim();
// //   //       }

// //   //       parsedNews.push({
// //   //         title,
// //   //         link,
// //   //         imageUrl,
// //   //         date: formattedDate,
// //   //         source,
// //   //       });
// //   //     });

// //   //     setNews(parsedNews);
// //   //   } catch (err) {
// //   //     console.error("RSS fetch failed:", err);
// //   //     setError(true);
// //   //   } finally {
// //   //     setLoading(false);
// //   //   }
// //   // }
// // // async function fetchNews(keywords) {
// // //   const controller = new AbortController();
// // //   const allNews = [];
// // //   const seenLinks = new Set();

// // //   try {
// // //     setLoading(true);

// // //     for (const query of keywords) {
// // //       const rssUrl = `https://news.google.com/rss/search?q=${encodeURIComponent(
// // //         query
// // //       )}&hl=en-US&gl=US&ceid=US:en`;

// // //       const response = await fetch(
// // //         `https://api.allorigins.win/raw?url=${encodeURIComponent(rssUrl)}`,
// // //         { signal: controller.signal }
// // //       );

// // //       const xmlText = await response.text();
// // //       const xml = new DOMParser().parseFromString(
// // //         xmlText,
// // //         "application/xml"
// // //       );

// // //       const items = Array.from(xml.querySelectorAll("item"));

// // //       items.forEach((item) => {
// // //         const title = item.querySelector("title")?.textContent || "";
// // //         const link = item.querySelector("link")?.textContent || "";

// // //         // 🧠 Deduplicate across queries
// // //         if (!seenLinks.has(link)) {
// // //           seenLinks.add(link);
// // //           allNews.push({
// // //             title,
// // //             link,
// // //             source:
// // //               item.querySelector("source")?.textContent || "Google News",
// // //             date: item.querySelector("pubDate")?.textContent || "",
// // //           });
// // //         }
// // //       });
// // //     }

// // //     setNews(allNews);
// // //   } catch (err) {
// // //     if (err.name !== "AbortError") {
// // //       console.error(err);
// // //       setError(true);
// // //     }
// // //   } finally {
// // //     setLoading(false);
// // //   }

// // //   return () => controller.abort();
// // // }

// // // ===============================
// // // utils
// // // ===============================
// // function fetchWithTimeout(url, timeout = 8000) {
// //   const controller = new AbortController();
// //   const id = setTimeout(() => controller.abort(), timeout);

// //   return fetch(url, { signal: controller.signal })
// //     .finally(() => clearTimeout(id));
// // }

// // function chunkArray(arr, size = 2) {
// //   const chunks = [];
// //   for (let i = 0; i < arr.length; i += size) {
// //     chunks.push(arr.slice(i, i + size));
// //   }
// //   return chunks;
// // }

// // // ===============================
// // // MAIN FUNCTION
// // // ===============================
// // async function fetchNews(keywords) {
// //   const controller = new AbortController();
// //   const seenLinks = new Set();

// //   try {
// //     setLoading(true);
// //     setError(false);

// //     // ❗ DO NOT clear existing news here
// //     // setNews([]); ❌

// //     // limit total keywords (important for proxy)
// //     const safeKeywords = keywords.slice(0, 8);

// //     // batch requests (2 at a time)
// //     const batches = chunkArray(safeKeywords, 2);

// //     for (const batch of batches) {
// //       const results = await Promise.allSettled(
// //         batch.map(async (query) => {
// //           try {
// //             const rssUrl =
// //               `https://news.google.com/rss/search?q=${encodeURIComponent(query)}` +
// //               `&hl=en-US&gl=US&ceid=US:en`;

// //             const proxyUrl =
// //               `https://api.allorigins.win/raw?url=${encodeURIComponent(rssUrl)}`;

// //             const response = await fetchWithTimeout(proxyUrl, 8000);

// //             if (!response.ok) {
// //               throw new Error(`HTTP ${response.status}`);
// //             }

// //             const xmlText = await response.text();

// //             const xml = new DOMParser().parseFromString(
// //               xmlText,
// //               "application/xml"
// //             );

// //             if (xml.querySelector("parsererror")) {
// //               throw new Error("Invalid XML");
// //             }

// //             return Array.from(xml.querySelectorAll("item"));
// //           } catch (err) {
// //             console.warn("RSS request failed:", query, err);
// //             return []; // ❗ fail silently per request
// //           }
// //         })
// //       );

// //       // append results immediately
// //       results.forEach((result) => {
// //         if (result.status !== "fulfilled") return;

// //         result.value.forEach((item) => {
// //           const link = item.querySelector("link")?.textContent;
// //           if (!link || seenLinks.has(link)) return;

// //           seenLinks.add(link);

// //           setNews((prev) => [
// //             ...prev,
// //             {
// //               title: item.querySelector("title")?.textContent || "",
// //               link,
// //               source:
// //                 item.querySelector("source")?.textContent || "Google News",
// //               date: item.querySelector("pubDate")?.textContent || "",
// //             },
// //           ]);
// //         });
// //       });
// //     }
// //   } catch (err) {
// //     if (err.name !== "AbortError") {
// //       console.error("Unexpected error:", err);
// //       setError(true);
// //     }
// //   } finally {
// //     setLoading(false);
// //   }

// //   return () => controller.abort();
// // }

// //   // async function fetchNews(searchQuery) {
// //   //   try {
// //   //     setLoading(true);
// //   //     setError(false);

// //   //     const rssUrl = `https://news.google.com/rss/search?q=${encodeURIComponent(
// //   //       searchQuery
// //   //     )}&hl=en-US&gl=US&ceid=US:en`;

// //   //     const response = await fetch(
// //   //       `https://api.allorigins.win/raw?url=${encodeURIComponent(rssUrl)}`
// //   //     );

// //   //     const xmlText = await response.text();

// //   //     const parser = new DOMParser();
// //   //     const xml = parser.parseFromString(xmlText, "application/xml");

// //   //     const items = Array.from(xml.querySelectorAll("item"));
// //   //     const parsedNews = [];

// //   //     items.forEach((item) => {
// //   //       const title = item.querySelector("title")?.textContent || "";
// //   //       const description =
// //   //         item.querySelector("description")?.textContent || "";
// //   //       const link = item.querySelector("link")?.textContent || "";
// //   //       const pubDate = item.querySelector("pubDate")?.textContent || "";
// //   //       const source =
// //   //         item.querySelector("source")?.textContent || "Google News";

// //   //       if (
// //   //         !title.toLowerCase().includes("trump") &&
// //   //         !description.toLowerCase().includes("trump")
// //   //       )
// //   //         return;

// //   //       const formattedDate = new Date(pubDate).toLocaleDateString("en-GB", {
// //   //         day: "2-digit",
// //   //         month: "short",
// //   //         year: "numeric",
// //   //       });

// //   //       let imageUrl = "";
// //   //       const mediaContent = item.querySelector("media\\:content, enclosure");

// //   //       if (mediaContent?.getAttribute("url")) {
// //   //         imageUrl = mediaContent.getAttribute("url").trim();
// //   //       } else {
// //   //         const match = description.match(/<img.*?src=["'](.*?)["']/);
// //   //         if (match?.[1]) imageUrl = match[1].trim();
// //   //       }

// //   //       parsedNews.push({
// //   //         title,
// //   //         link,
// //   //         imageUrl,
// //   //         date: formattedDate,
// //   //         source,
// //   //       });
// //   //     });

// //   //     setNews(parsedNews);
// //   //   } catch (err) {
// //   //     console.error("RSS fetch failed:", err);
// //   //     setError(true);
// //   //   } finally {
// //   //     setLoading(false);
// //   //   }
// //   // }

// //   if (loading)
// //     return (
// //       <Stack spacing={2}>
// //         {Array.from({ length: 6 }).map((_, i) => (
// //           <Box
// //             key={i}
// //             sx={{
// //               display: "flex",
// //               gap: 2,
// //               alignItems: "flex-start",
// //             }}
// //           >
// //             {/* Image */}
// //             <Skeleton
// //               variant="rectangular"
// //               width={90}
// //               height={60}
// //               sx={{ borderRadius: 1 }}
// //             />

// //             {/* Text */}
// //             <Box sx={{ flex: 1 }}>
// //               <Skeleton width="90%" height={22} />
// //               <Skeleton width="75%" height={22} />
// //               <Skeleton width="40%" height={16} sx={{ mt: 0.5 }} />
// //             </Box>
// //           </Box>
// //         ))}
// //       </Stack>
// //     );
// //   if (error) return <p>Error loading news.</p>;
// //   if (!news.length) return <p>No relevant news found.</p>;

// //   return (
// //     <div id="twitter-news-wrapper">
// //       {news.map((item, index) => (
// //         <div className="anchor-bunches" key={index}>
// //           <a
// //             href={item.link}
// //             target="_blank"
// //             rel="noopener noreferrer"
// //             className="new-sec"
// //           >
// //             {item.title}
// //           </a>

// //           {item.imageUrl && (
// //             <img
// //               src={item.imageUrl}
// //               alt=""
// //               className="news-img"
// //               onError={(e) => (e.target.style.display = "none")}
// //             />
// //           )}

// //           <p>
// //             {item.date} – {item.source}
// //           </p>
// //         </div>
// //       ))}
// //     </div>
// //   );
// // }

// import { Box, Skeleton, Stack } from "@mui/material";
// import { useEffect, useRef, useState } from "react";
// import axiosInstance from "../Utils/AxoisClient";

// /* ===============================
//    Utils
// ================================ */

// function fetchWithTimeout(url, signal, timeout = 8000) {
//   const controller = new AbortController();
//   const id = setTimeout(() => controller.abort(), timeout);

//   const combinedSignal = signal
//     ? new AbortController([controller.signal, signal]).signal
//     : controller.signal;

//   return fetch(url, { signal: combinedSignal }).finally(() => clearTimeout(id));
// }

// function chunkArray(arr, size = 1) {
//   const chunks = [];
//   for (let i = 0; i < arr.length; i += size) {
//     chunks.push(arr.slice(i, i + size));
//   }
//   return chunks;
// }

// /* ===============================
//    Component
// ================================ */

// export default function GoogleNews({
//   query,
//   originCountries,
//   destinationCountry,
// }) {
//   const [news, setNews] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(false);

//   const seenLinksRef = useRef(new Set());

//   // useEffect(() => {
//   //   setNews([]);
//   //   setLoading(true);
//   //   setError(false);
//   //   seenLinksRef.current.clear();
//   // }, [country]);

//   const debounceNewsRef = useRef(null);

//   useEffect(() => {
//     if (!query || !query.length) {
//       setLoading(false);
//       return;
//     }

//     // Show loading immediately
//     setLoading(true);

//     // Clear previous debounce timer
//     if (debounceNewsRef.current) {
//       clearTimeout(debounceNewsRef.current);
//     }

//     const controller = new AbortController();

//     // Debounce: wait 500ms for values to settle before calling API
//     debounceNewsRef.current = setTimeout(() => {
//       setNews([]);
//       setError(false);
//       seenLinksRef.current.clear();
//       fetchNews(query, originCountries, destinationCountry, controller.signal);
//     }, 1000);

//     return () => {
//       clearTimeout(debounceNewsRef.current);
//       controller.abort();
//     };
//   }, [query, originCountries, destinationCountry]);

//   // async function fetchNews(keywords, signal) {
//   //   try {
//   //     const safeKeywords = keywords.slice(0, 6); // avoid 429
//   //     const batches = chunkArray(safeKeywords, 1); // 1 at a time

//   //     for (const batch of batches) {
//   //       if (signal.aborted) return;

//   //       await Promise.allSettled(
//   //         batch.map(async (q) => {
//   //           try {
//   //             const rssUrl =
//   //               `https://news.google.com/rss/search?q=${encodeURIComponent(q)}` +
//   //               `&hl=en-US&gl=US&ceid=US:en`;

//   //             const proxyUrl =
//   //               `https://api.allorigins.win/raw?url=${encodeURIComponent(
//   //                 rssUrl
//   //               )}`;

//   //             const res = await fetchWithTimeout(proxyUrl, signal);

//   //             if (!res.ok) throw new Error(res.status);

//   //             const xmlText = await res.text();
//   //             const xml = new DOMParser().parseFromString(
//   //               xmlText,
//   //               "application/xml"
//   //             );

//   //             if (xml.querySelector("parsererror")) return;

//   //             Array.from(xml.querySelectorAll("item")).forEach((item) => {
//   //               const link = item.querySelector("link")?.textContent;
//   //               if (!link || seenLinksRef.current.has(link)) return;

//   //               seenLinksRef.current.add(link);

//   //               setNews((prev) => [
//   //                 ...prev,
//   //                 {
//   //                   title:
//   //                     item.querySelector("title")?.textContent || "",
//   //                   link,
//   //                   source:
//   //                     item.querySelector("source")?.textContent ||
//   //                     "Google News",
//   //                   date: item.querySelector("pubDate")?.textContent || "",
//   //                 },
//   //               ]);
//   //             });
//   //           } catch (err) {
//   //             console.warn("Skipped request:", err);
//   //           }
//   //         })
//   //       );

//   //       // ⏳ cooldown → prevents 429
//   //       await new Promise((r) => setTimeout(r, 1200));
//   //     }
//   //   } catch (err) {
//   //     if (!signal.aborted) {
//   //       console.error(err);
//   //       setError(true);
//   //     }
//   //   } finally {
//   //     if (!signal.aborted) setLoading(false);
//   //   }
//   // }

//   // async function fetchNews(keywords, signal) {
//   //   try {
//   //     const safeKeywords = keywords.slice(0, 6); // avoid 429
//   //     const batches = chunkArray(safeKeywords, 1); // 1 at a time

//   //     for (const batch of batches) {
//   //       if (signal.aborted) return;

//   //       const batchItems = [];

//   //       await Promise.allSettled(
//   //         batch.map(async (q) => {
//   //           try {
//   //             const rssUrl =
//   //               `https://news.google.com/rss/search?q=${encodeURIComponent(q)}` +
//   //               `&hl=en-US&gl=US&ceid=US:en`;
//   //             const proxyUrl = `https://api.allorigins.win/raw?url=${encodeURIComponent(
//   //               rssUrl,
//   //             )}`;

//   //             const res = await fetchWithTimeout(proxyUrl, signal);
//   //             if (!res.ok) throw new Error(res.status);

//   //             const xmlText = await res.text();
//   //             const xml = new DOMParser().parseFromString(
//   //               xmlText,
//   //               "application/xml",
//   //             );

//   //             if (xml.querySelector("parsererror")) return;

//   //             Array.from(xml.querySelectorAll("item")).forEach((item) => {
//   //               const link = item.querySelector("link")?.textContent;
//   //               if (!link || seenLinksRef.current.has(link)) return;

//   //               seenLinksRef.current.add(link);

//   //               const pubDateText =
//   //                 item.querySelector("pubDate")?.textContent || "";

//   //               const timestamp = pubDateText
//   //                 ? new Date(pubDateText).getTime()
//   //                 : 0;

//   //               batchItems.push({
//   //                 title: item.querySelector("title")?.textContent || "",
//   //                 link,
//   //                 source:
//   //                   item.querySelector("source")?.textContent || "Google News",
//   //                 date: pubDateText, // display
//   //                 timestamp, // sorting
//   //               });
//   //             });
//   //           } catch (err) {
//   //             console.warn("Skipped request:", err);
//   //           }
//   //         }),
//   //       );

//   //       // 🔥 merge + sort ONCE per batch
//   //       if (batchItems.length) {
//   //         setNews((prev) => {
//   //           const merged = [...prev, ...batchItems];
//   //           merged.sort((a, b) => b.timestamp - a.timestamp); // newest first
//   //           return merged;
//   //         });
//   //       }

//   //       // ⏳ cooldown → prevents 429
//   //       await new Promise((r) => setTimeout(r, 1200));
//   //     }
//   //   } catch (err) {
//   //     if (!signal.aborted) {
//   //       console.error(err);
//   //       setError(true);
//   //     }
//   //   } finally {
//   //     if (!signal.aborted) setLoading(false);
//   //   }
//   // }

//   // const fetchNews = async (
//   //   keyword,
//   //   sourcingCountry,
//   //   destinationCountry,
//   //   signal,
//   // ) => {
//   //   console.log(keyword, 'difgijbj');

//   //   try {
//   //     const res = await axiosInstance.get(
//   //       `company/news?type=${keyword}&source_country=${sourcingCountry}&destination_country=${destinationCountry}`,
//   //     );

//   //     console.log(res.data.data, 'fgdf');

//   //     setNews(res.data.data);
//   //   } catch (err) {
//   //     console.log(err, 'dfsdfs');

//   //     setLoading(false);
//   //   }
//   // };

//   const fetchNews = async (
//   keyword,
//   sourcingCountry,
//   destinationCountry,
//   signal,
// ) => {
//   try {
//     const res = await axiosInstance.get(
//       `company/news?type=${keyword}&source_country=${sourcingCountry}&destination_country=${destinationCountry}`,
//       { signal },
//     );
//     setNews(res.data.data);
//   } catch (err) {
//     if (err.name === "CanceledError" || err.code === "ERR_CANCELED") return;
//     setError(true);
//   } finally {
//     setLoading(false);
//   }
// };

//   /* ===============================
//      UI
//   ================================ */

//   if (loading)
//     return (
//       <Stack spacing={2}>
//         {Array.from({ length: 6 }).map((_, i) => (
//           <Box
//             key={i}
//             sx={{ display: "flex", gap: 2, alignItems: "flex-start" }}
//           >
//             <Skeleton
//               variant="rectangular"
//               width={90}
//               height={60}
//               sx={{ borderRadius: 1 }}
//             />
//             <Box sx={{ flex: 1 }}>
//               <Skeleton width="90%" height={22} />
//               <Skeleton width="75%" height={22} />
//               <Skeleton width="40%" height={16} sx={{ mt: 0.5 }} />
//             </Box>
//           </Box>
//         ))}
//       </Stack>
//     );

//   if (error) return <p>Error loading news.</p>;
//   if (!news.length) return <p>No relevant news found.</p>;

//   return (
//     <div id="twitter-news-wrapper">
//       {news.map((item, index) => (
//         <div className="anchor-bunches" key={index}>
//           <a
//             href={item.link}
//             target="_blank"
//             rel="noopener noreferrer"
//             className="new-sec"

//           >
//             {item.title}
//           </a>

//           <p>
//             {item.date} – {item.source}
//           </p>
//         </div>
//       ))}
//     </div>
//   );
// }

import { Box, Skeleton, Stack, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import axiosInstance from "../Utils/AxoisClient";

const NewsBoxIcon = () => (
  <Box
    sx={{
      width: 40,
      height: 40,
      borderRadius: 2,
      flexShrink: 0,
      background: "linear-gradient(135deg, #eef2ff 0%, #e0e7ff 100%)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
    >
      <rect
        x="2.5"
        y="4.5"
        width="19"
        height="15"
        rx="1.5"
        stroke="#6366f1"
        strokeWidth="1.4"
      />
      <path
        d="M6 8.5H12M6 11.5H12M6 14.5H10"
        stroke="#6366f1"
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <rect
        x="14.5"
        y="8"
        width="4"
        height="4"
        rx="0.5"
        stroke="#6366f1"
        strokeWidth="1.4"
      />
    </svg>
  </Box>
);

/* ===============================
   Utils
================================ */

function fetchWithTimeout(url, signal, timeout = 8000) {
  const controller = new AbortController();
  const id = setTimeout(() => controller.abort(), timeout);

  const combinedSignal = signal
    ? new AbortController([controller.signal, signal]).signal
    : controller.signal;

  return fetch(url, { signal: combinedSignal }).finally(() => clearTimeout(id));
}

function chunkArray(arr, size = 1) {
  const chunks = [];
  for (let i = 0; i < arr.length; i += size) {
    chunks.push(arr.slice(i, i + size));
  }
  return chunks;
}

/* ===============================
   Component
================================ */

export default function GoogleNews({
  query,
  originCountries,
  destinationCountry,
}) {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const seenLinksRef = useRef(new Set());
  const debounceNewsRef = useRef(null);

  useEffect(() => {
    if (!query || !query.length) {
      setLoading(false);
      return;
    }

    setLoading(true);

    if (debounceNewsRef.current) {
      clearTimeout(debounceNewsRef.current);
    }

    const controller = new AbortController();

    debounceNewsRef.current = setTimeout(() => {
      setNews([]);
      setError(false);
      seenLinksRef.current.clear();
      fetchNews(query, originCountries, destinationCountry, controller.signal);
    }, 1000);

    return () => {
      clearTimeout(debounceNewsRef.current);
      controller.abort();
    };
  }, [query, originCountries, destinationCountry]);

  const fetchNews = async (
    keyword,
    sourcingCountry,
    destinationCountry,
    signal,
  ) => {
    try {
      const res = await axiosInstance.get(
        `company/news?type=${keyword}&source_country=${sourcingCountry}&destination_country=${destinationCountry}`,
        { signal },
      );
      setNews(res.data.data);
    } catch (err) {
      if (err.name === "CanceledError" || err.code === "ERR_CANCELED") return;
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  /* ===============================
     UI
  ================================ */

  if (loading)
    return (
      <Stack spacing={1.25}>
        {Array.from({ length: 6 }).map((_, i) => (
          <Box
            key={i}
            sx={{
              display: "flex",
              gap: 1.75,
              alignItems: "flex-start",
              p: 1.5,
              borderRadius: 3,
              border: "1px solid #eef0f4",
            }}
          >
            <Skeleton
              variant="rounded"
              width={56}
              height={56}
              sx={{ borderRadius: 2, flexShrink: 0 }}
            />
            <Box sx={{ flex: 1 }}>
              <Skeleton width="35%" height={20} sx={{ borderRadius: 2, mb: 0.5 }} />
              <Skeleton width="95%" height={18} />
              <Skeleton width="70%" height={18} />
            </Box>
          </Box>
        ))}
      </Stack>
    );

  if (error) return <p>Error loading news.</p>;
  if (!news.length) return <p>No relevant news found.</p>;

  return (
    <Stack spacing={1.25}>
      {news.map((item, index) => (
        <Box
          key={index}
          component="a"
          href={item.link}
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            display: "flex",
            gap: 1.75,
            alignItems: "flex-start",
            p: 1.5,
            borderRadius: 3,
            border: "1px solid #eef0f4",
            background: "#fff",
            textDecoration: "none",
            transition: "all 0.2s ease",
            "&:hover": {
              borderColor: "#c7d2fe",
              boxShadow: "0 6px 16px rgba(79, 70, 229, 0.08)",
              transform: "translateY(-1px)",
              "& .news-icon-tile": {
                background: "linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)",
              },
              "& .news-icon-tile svg rect, & .news-icon-tile svg path": {
                stroke: "#fff",
              },
              "& .news-title": { color: "#4f46e5" },
            },
          }}
        >
          {/* Left: Icon */}
          <NewsBoxIcon />

          {/* Right: Date/source badge + Link title */}
          <Box sx={{ flex: 1, minWidth: 0 }}>
            {item.date && (
              <Box
                sx={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 0.5,
                  fontSize: 10.5,
                  fontWeight: 600,
                  letterSpacing: 0.2,
                  color: "#6366f1",
                  background: "#eef2ff",
                  borderRadius: "999px",
                  px: 1,
                  py: 0.25,
                  mb: 0.75,
                }}
              >
                {item.date}
                {item.source ? ` · ${item.source}` : ""}
              </Box>
            )}

            {/* News link title */}
            <Typography
              className="news-title"
              sx={{
                fontSize: 13.5,
                fontWeight: 600,
                color: "#1e293b",
                lineHeight: 1.45,
                display: "-webkit-box",
                WebkitLineClamp: 3,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
                transition: "color 0.2s ease",
              }}
            >
              {item.title}
            </Typography>
          </Box>
        </Box>
      ))}
    </Stack>
  );
}
